<h2 mat-dialog-title class="text-center">
  {{ data.title }}
</h2>

<div mat-dialog-content class="text-center h-100" fxLayout="column" fxLayoutAlign="center center">


  <p [ngClass]="{'pre-wrap': data.preWrapMessage ?? false }">{{data.message}}</p>


  <div fxFlexAlign="stretch" fxLayout="row wrap" fxLayoutAlign="space-evenly">
    <button [matDialogClose]="false" class="mt-2_5" color="warn" mat-button>Cancel</button>
    <button [matDialogClose]="true" class="mt-2_5" mat-button>{{(data.confirmTextKey ? data.confirmTextKey :
      'Confirm')}}</button>
  </div>
</div>
